// SpotSnap.jsx
import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import '../../styles/SpotSnap.css';

const SpotSnapInfo = () => {

    return (
        <MainLayout>
            <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
                <h2>SpotSnap Info & Rules</h2>
            </div>
            <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
                <div className="spotsnap-group gift-group flex justify-center items-center flex-col">
                    <div className="flex justify-center items-center">
                        <p className="text-yellow-500 text-5xl"><FontAwesomeIcon icon={faGift} /></p>
                    </div>
                    <div className="flex justify-center items-center">
                        <p className="text-yellow-500 text-center text-3xl">Lucky Winners Will Get A Gift</p>
                    </div>
                </div>
                {/* <div className="spotsnap-container"> */}
                <div className="spotsnap-group info-group align-middle">
                    <p className="spotsnap-heading">SpotSnap: Find Your Moments</p><br />
                    <p> Transforms image exploration into a daily adventure, uncover hidden treasures and share
                        the discoveries with friends.
                    </p><br />
                    <p>
                        With SpotSnap, every click becomes an exciting opportunity to explore the world around
                        you and find joy in the little things. Whether it's spotting a beautiful sunset,
                        a quirky street art, or a nostalgic childhood memory, SpotSnap turns everyday moments
                        into memorable experiences.
                    </p><br />
                    <p>
                        Join the SpotSnap community and embark on a daily journey of discovery,
                        one click at a time. Let SpotSnap add a splash of fun and excitement to your day as you
                        explore, snap, and share your favorite spots with the world.
                    </p><br />
                    <h1 className="spotsnap-heading text-yellow-500 mt-6">Your Problem</h1>
                    <p>
                        You will see a picture<br />
                        And instructions on what is expected
                    </p>
                    <h1 className="spotsnap-heading text-yellow-500 mt-6">Steps to follow</h1>
                    <p>
                        1. Spot the mistake<br />
                        2. Double Clicked<br />
                        3. Submit<br />
                        4. View Your Spot on SpotSnap Leaderboard<br />
                        5. Revisit Next Day and check if you are amongst lucky winners<br />
                        6. Claim Your Prize<br />
                        7. We will respond within 1 working day
                    </p>
                </div>
            </div>
        </MainLayout>
    );
};

export default SpotSnapInfo;

